import { Title } from "./title.js"
import { LevelTitle } from "./levels/level-title.js"
import { CleanHouse } from "./levels/clean-house.js"
import { DecorateYourLivingroom } from "./levels/decorate-your-livingroom.js"
import { Neighborhood } from "./levels/neighborhood.js"
import { GreetNeighbors } from "./levels/greet-neighbors.js"
import { BuyNewClothes } from "./levels/buy-new-clothes.js"
import { LionDance } from "./levels/lion-dance.js"
import { ServeAFeast } from "./levels/serve-a-feast.js"
import { LanternWishes } from "./levels/lantern-wishes.js"
import { GameOver } from "./game-over.js";

class Walker extends Phaser.Game {
    constructor() {
        super({
            type: Phaser.AUTO,
            width: 1200,
            height: 675,
            backgroundColor: '#fff',
            parent: "px-walker",
            physics: {
                default: "arcade",
                arcade: {debug: false}
            }
        })
        this.level = {
            all: [ CleanHouse, DecorateYourLivingroom, Neighborhood, BuyNewClothes, GreetNeighbors, LionDance, ServeAFeast, LanternWishes ],
            current: { index: 0, keys: [] },
            latest: 0,
            home: this.home.bind(this),
            play: {
                title: this.playLevelTitle.bind(this),
                level: this.playLevel.bind(this),
                next: this.playNextLevel.bind(this),
                latest: this.playLatestLevel.bind(this)
            },
            win: this.winLevel.bind(this),
            reset: this.reset.bind(this)
        }
        this._title = new Title(this.level)
        this.scene.add("title", this._title, true)
    }
    home() {
        const l = this.level
        this.scene.resume("title")
        this.sound.stopAll()
        this._title.playHomeMusic()
        l.current.keys.forEach(k => this.scene.remove(k))
        if (l.latest !== 0 ) this._title.updateStartButton("NEXT")
        if (l.current.index >= l.all.length) this.gameOver()
    }
    playLevelTitle(index) {
        const l = this.level
        l.current.index = index
        const key = `l${index}-title`
        this.scene.add(key, new LevelTitle(key, l, l.all[index]), true)
        l.current.keys.push(key)
        this.scene.pause("title")
    }
    playLevel() {
        const l = this.level
        l.current.keys.forEach(k => this.scene.pause(k))
        const index = l.current.index
        const key = `l${index}-level`
        l.current.keys.push(key)
        const level = new l.all[index](key, l)
        this.scene.add(key, level, true)
    }
    playNextLevel() {
        const l = this.level
        if (l.current.index >= l.all.length) { this.gameOver(); return }
        l.current.keys.forEach(k => this.scene.remove(k))
        this.playLevelTitle(l.current.index)
    }
    playLatestLevel() {
        const l = this.level
        if (l.current.index >= l.all.length) { this.gameOver(); return }
        l.current.keys.forEach(k => this.scene.remove(k))
        this.playLevelTitle(l.latest)
    }
    winLevel() {
        const l = this.level
        l.all[l.current.index].info.won = true
        if (l.latest === l.current.index) l.latest++
        l.current.index++
    }
    gameOver() {
        const l = this.level
        l.current.keys.forEach(k => this.scene.remove(k))
        this.scene.remove("title")
        this.scene.add("game-over", new GameOver(this.level), true)
    }
    reset() {
        const l = this.level
        l.current.keys.forEach(k => this.scene.remove(k))
        this.scene.remove("title").remove("game-over")
        l.current.index = 0
        l.latest = 0
        l.all.forEach(c => c.info.won = false)
        this._title = new Title(this.level)
        this.scene.add("title", this._title, true)
    }
}
window.walker = new Walker()
